
import httpbaseURL from '../../../../modules/Inventory/common/axios';
class DisposalService {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetDisposal/Create", doc)
    }
    updateapproval(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetDisposal/UpdateDisposalApproval", doc)
    }
    getdata(StoreId, BranchId, HospitalId, startDate, endDate, pageNum, pageSize) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetDisposal/ListDisposal?StoreId=" + StoreId + "&BranchId=" + BranchId + "&HospitalId=" + HospitalId + "&startDate=" + startDate + "&endDate=" + endDate + "&pageNum=" + pageNum + "&pageSize=" + pageSize)
    }
    updateplan(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetDisposal/UpdateDisposalPlanning", doc)
    }
    updateplangetdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetDisposal/Get?id=" + doc)
    }

}
export default new DisposalService()

